import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdLock, MdVisibility, MdVisibilityOff } from "react-icons/md";
import { toast } from "react-toastify";

const ForgotPasswordPage = () => {
  const [newPassword, setNewPassword] = useState("");
  const [reenterPassword, setReenterPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [t] = useTranslation("global");
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleReset = (e) => {
    e.preventDefault();

    if (!newPassword || !reenterPassword) {
      toast.error(t("forgotPassword.Both fields are required."));
      return;
    }

    if (newPassword !== reenterPassword) {
      toast.error(t("forgotPassword.Passwords do not match."));
      return;
    }

    toast.success(t("forgotPassword.Password updated successfully!"));
    // Submit to API here
  };

  return (
    <div className="forgot-password-page d-flex align-items-center justify-content-center vh-100 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="shadow-lg rounded-4 p-4">
              <Card.Body>
                <div className="text-center mb-4">
                  <img
                    src="/Assets/logo5.png"
                    alt="none"
                    className="img-fluid"
                    width={180}
                  />
                  <h3>🔐 {t("forgotPassword.Reset Your Password")}</h3>
                  <p className="text-muted">
                    {t(
                      "forgotPassword.Regain access to your account quickly and securely"
                    )}
                  </p>
                </div>
                <Form onSubmit={handleReset}>
                  <Form.Group className="mb-3" controlId="newPassword">
                    <Form.Label>{t("forgotPassword.New Password")}</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-white">
                        <MdLock />
                      </span>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder={t("forgotPassword.Enter new password")}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span
                        className="input-group-text bg-white"
                        style={{ cursor: "pointer" }}
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                      </span>
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="reenterPassword">
                    <Form.Label>
                      {t("forgotPassword.Re-enter New Password")}
                    </Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-white">
                        <MdLock />
                      </span>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder={t("forgotPassword.Re-enter new password")}
                        value={reenterPassword}
                        onChange={(e) => setReenterPassword(e.target.value)}
                      />
                      <span
                        className="input-group-text bg-white"
                        style={{ cursor: "pointer" }}
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                      </span>
                    </div>
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mt-3 forgot-btn"
                  >
                    {t("forgotPassword.Update Password")}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPasswordPage;


  // "forgotPassword": {
  //   "Reset Your Password": "Reset Your Password",
  //   "Regain access to your account quickly and securely": "Regain access to your account quickly and securely",
  //   "New Password": "New Password",
  //   "Enter new password": "Enter new password",
  //   "Re-enter New Password": "Re-enter New Password",
  //   "Re-enter new password": "Re-enter new password",

  //   "Update Password": "Update Password",
  //   "Both fields are required.": "Both fields are required.",
  //   "Passwords do not match.": "Passwords do not match.",
  //   "Password updated successfully!": "Password updated successfully!"
  // },